/**
 * Checks if the passed in object is a non-empty array.
 */
export const isNonEmptyArray = (arr: unknown): arr is unknown[] => Array.isArray(arr) && arr.length !== 0;
